<h1 *header="'Referral'; d9: '#block-pac-theme-pagetitle h1.title'; let title" class="page-header">{{ title }}</h1>

<app-signup-header></app-signup-header>

<ng-container *ngIf="Referral else loading">
  <form (ngSubmit)="Submit()">
    <fieldset [bs3Class]="['panel-primary']" class="panel">
      <div [bs4Class]="['bg-primary', 'text-light']" class="panel-heading">Referred By</div>
      <div class="panel-body">
        <p>Thanks for letting us know who told you about {{ Settings.pac_base_asn_code }}.</p>

        <div class="form-group">
          <label for="input-state" class="control-label">First Name</label>
          <div class="input-group">
            <ng-container bsMigrationPicker [bs3]="fNameBs3" [bs4]="fNameBs4">
              <ng-template #fNameBs4>
                <input type="text" readonly class="form-control-plaintext"
                  [value]=" Referral.ind_badge_name || Referral.ind_first_name">
              </ng-template>
              <ng-template #fNameBs3>
                <p class="form-control-static">{{ Referral.ind_badge_name || Referral.ind_first_name }}</p>
              </ng-template>
            </ng-container>
          </div>
        </div>
        <div class="form-group">
          <label for="input-state" class="control-label">Last Name</label>
          <div class="input-group">
            <ng-container bsMigrationPicker [bs3]="lNameBs3" [bs4]="lNameBs4">
              <ng-template #lNameBs4>
                <input type="text" readonly class="form-control-plaintext" [value]="Referral.ind_last_name">
              </ng-template>
              <ng-template #lNameBs3>
                <p class="form-control-static">{{ Referral.ind_last_name }}</p>
              </ng-template>
            </ng-container>
          </div>
        </div>
        <div class="form-group">
          <label for="input-state" class="control-label">Member ID</label>
          <div class="input-group">
            <ng-container bsMigrationPicker [bs3]="idBs3" [bs4]="idBs4">
              <ng-template #idBs4>
                <input type="text" readonly class="form-control-plaintext" [value]="Referral.cst_recno">
              </ng-template>
              <ng-template #idBs3>
                <p class="form-control-static">{{ Referral.cst_recno }}</p>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </div>
    </fieldset>
    <p>
      <button class="btn btn-primary" [disabled]="!ready()" type="submit">Continue</button>
    </p>
  </form>
</ng-container>

<ng-template #loading>
  <p><br /><br /><strong>Loading...</strong><br /><br /></p>
</ng-template>